import React, { useEffect } from 'react';
import TimerWidgetController from './controllers/TimerWidgetController';
import classNames from 'classnames';
import styles from '../facilitation/timer/Timer.module.css';
import {
  ApplicationView,
  StartControllerScope,
  useController,
} from '@aha-app/mvc';

const TimerWidgetComponent: React.FC = () => {
  const controller = useController(TimerWidgetController);

  const { running, remainingDurationText, widget } = controller.state;

  const expired = widget?.expired() || (running && !widget?.active());
  const counting = running && widget?.active() && !widget.paused() && !expired;

  useEffect(() => {
    if (!counting) return;

    const countdown = setInterval(() => {
      controller.actionUpdateRemainingDuration();
    }, 1000);

    return () => clearInterval(countdown);
  }, [counting]);

  if (!controller.visible() || !widget) return null;

  const iconType = expired ? 'fa-alarm-clock' : 'fa-timer';

  return (
    <div className={styles.widgetContainer}>
      {widget.paused() ? (
        <i
          className={classNames(
            styles.widgetIcon,
            styles.paused,
            'fa-solid',
            'fa-pause'
          )}
        />
      ) : (
        <i className={classNames(styles.widgetIcon, 'fa-regular', iconType)} />
      )}

      <div
        className={classNames(styles.widgetText, {
          [styles.paused]: widget.paused(),
          [styles.orange]: widget.warningTime(),
          [styles.red]: widget.dangerTime(),
          [styles.expired]: expired,
        })}
      >
        {expired ? 'Time is up' : remainingDurationText}
      </div>
      {expired && (
        <i
          className={classNames(styles.close, 'fa-regular', 'fa-xmark')}
          onClick={() => controller.actionStopWidget()}
        />
      )}
    </div>
  );
};

const ControlledTimerWidgetComponent = StartControllerScope(
  TimerWidgetController,
  ApplicationView(TimerWidgetComponent)
);

export default ControlledTimerWidgetComponent;
